const filter = string => {
    if (!string) {
        return ''
    }

    const strLowerCase = string.toLowerCase()
    return strLowerCase[0].toUpperCase() + strLowerCase.substr(1, string.length)
}

export default filter